import { TCreatePortionAction, CreatePortionActionTypes } from './createPortionActions';
import { ICreatePortionState } from './createPortionContext';

export const createPortionReducer = (state: ICreatePortionState, action: TCreatePortionAction): ICreatePortionState => {
	switch (action.type) {
		case CreatePortionActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: action.payload.fetchedRestaurants,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				nameOfDish: action.payload.nameOfDish,
				dishId: action.payload.dishId,
				isCreatedOnPos: action.payload.isCreatedOnPos,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
				translations: action.payload.translations,
			};
		case CreatePortionActionTypes.CHANGE_NAME_OF_PORTION:
			return {
				...state,
				nameOfPortion: action.payload.nameOfPortion,
			};
		case CreatePortionActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case CreatePortionActionTypes.CHANGE_PRICE_STRATEGY:
			return {
				...state,
				priceStrategy: action.payload.priceStrategy,
			};
		case CreatePortionActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case CreatePortionActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC:
			return {
				...state,
				isProtectedFromSync: !state.isProtectedFromSync,
			};
		case CreatePortionActionTypes.TOGGLE_IS_DISABLED:
			return {
				...state,
				isDisabled: !state.isDisabled,
			};
		// case CreatePortionActionTypes.SET_FETCHED_TRANSLATIONS:
		// 	return {
		// 		...state,
		// 		translations: action.payload.translations,
		// 		defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
		// 	};
		case CreatePortionActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreatePortionActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreatePortionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case CreatePortionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case CreatePortionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
